// src/App.js
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import CssBaseline from '@mui/material/CssBaseline';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Pages
import NotFound from './pages/NotFound';
import AppLayout from './layout/AppLayout';
import ListReadingPractice from './features/readingPractice/pages/ListReadingPractice';
import ListPracticeCollection from './features/practiceCollection/pages/ListPracticeCollection';
import ListPracticePathway from './features/practiceCollection/pages/ListPracticePathway';
import PracticeCollectionDetails from './features/practiceCollection/pages/PracticeCollectionDetails';
import PracticeCollectionRequestDetails from './features/practiceCollection/pages/PracticeCollectionRequestDetails';
import ContentEditor from './features/readingPractice/pages/ContentEditor';
import ReadingPracticeDetails from './features/readingPractice/pages/ReadingPracticeDetails/index.js';
import ReadabilityTools from './features/readability/pages/ReadabilityTools/index.js';
import RequestsList from './features/readingPractice/pages/ReadingPracticeRequestsList/index.js';
import RequestDetail from './features/readingPractice/pages/ReadingPracticeRequestDetail/index.js';

// Auth components
import { AuthProvider } from './context/AuthContext';
import LoginPage from './pages/LoginPage/index.js';
import ProtectedRoute from './components/common/ProtectedRoute.js';
import DashboardPage from './pages/DashboardPage/index.js';


function App() {
  return (
    <ThemeProvider>
      <CssBaseline />
      <ToastContainer position="top-right" autoClose={3000} />
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <AuthProvider>
          <Routes>
            {/* Auth routes */}
            <Route path="/login" element={
              <>
                <LoginPage />
              </>
            } />



            {/* Protected routes */}
            {/* Redirect root to practice when not logged in */}
            <Route path="/" element={
              <ProtectedRoute>
                <AppLayout>
                  <ListReadingPractice />
                </AppLayout>
              </ProtectedRoute>
            } />

            <Route path="/readability" element={
              <ProtectedRoute>
                <AppLayout>
                  <ReadabilityTools />
                </AppLayout>
              </ProtectedRoute>
            } />

            <Route path="/dashboard" element={
              <ProtectedRoute>
                <AppLayout>
                  <DashboardPage />
                </AppLayout>
              </ProtectedRoute>
            } />

            <Route path="/practice" element={
              <ProtectedRoute>
                <AppLayout>
                  <ListReadingPractice />
                </AppLayout>
              </ProtectedRoute>
            } />


            <Route path="/requests" element={
              <ProtectedRoute>
                <AppLayout>
                  <RequestsList />
                </AppLayout>
              </ProtectedRoute>
            } />

            <Route path="/requests/:id" element={
              <ProtectedRoute>
                <AppLayout>
                  <RequestDetail />
                </AppLayout>
              </ProtectedRoute>
            } />


            <Route path="/practice" element={
              <ProtectedRoute>
                <AppLayout>
                  <ListReadingPractice />
                </AppLayout>
              </ProtectedRoute>
            } />

            <Route path="/practice-collections" element={
              <ProtectedRoute>
                <AppLayout>
                  <ListPracticeCollection />
                </AppLayout>
              </ProtectedRoute>
            } />

            <Route path="/practice-pathways" element={
              <ProtectedRoute>
                <AppLayout>
                  <ListPracticePathway />
                </AppLayout>
              </ProtectedRoute>
            } />

            <Route path="/practice-collections/requests/:id" element={
              <ProtectedRoute>
                <AppLayout>
                  <PracticeCollectionRequestDetails />
                </AppLayout>
              </ProtectedRoute>
            } />

            <Route path="/practice-collections/:id" element={
              <ProtectedRoute>
                <AppLayout>
                  <PracticeCollectionDetails />
                </AppLayout>
              </ProtectedRoute>
            } />


            {/* Content routes */}
            <Route path="/reading-practices/:type/:id" element={
              <ProtectedRoute>
                <AppLayout>
                  <ReadingPracticeDetails />
                </AppLayout>
              </ProtectedRoute>
            } />

            <Route path="/reading-practices/:type/:id/edit" element={
              <ProtectedRoute>
                <AppLayout>
                  <ContentEditor />
                </AppLayout>
              </ProtectedRoute>
            } />

            {/* Fallback route */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;